export const categories = [
  { slug: "lianai", name: "恋爱", icon: "ri-heart-line", count: 2180 },
  { slug: "dushi", name: "都市", icon: "ri-building-line", count: 1856 },
  { slug: "xuanyi", name: "悬疑", icon: "ri-search-eye-line", count: 1423 },
  { slug: "dongzuo", name: "动作", icon: "ri-flashlight-line", count: 1650 },
  { slug: "kongbu", name: "恐怖", icon: "ri-ghost-line", count: 987 },
  { slug: "gaoxiao", name: "搞笑", icon: "ri-emotion-laugh-line", count: 1234 },
  { slug: "qihuan", name: "奇幻", icon: "ri-magic-line", count: 1567 },
  { slug: "xuanhuan", name: "玄幻", icon: "ri-star-line", count: 1890 },
  { slug: "xiaoen", name: "校园", icon: "ri-book-open-line", count: 1120 },
  { slug: "guzhuang", name: "古装", icon: "ri-ancient-gate-line", count: 876 },
  { slug: "kehuan", name: "科幻", icon: "ri-rocket-line", count: 654 },
  { slug: "tiyu", name: "体育", icon: "ri-basketball-line", count: 432 },
];

export const statusLabels: Record<string, string> = {
  serializing: '连载中',
  completed: '已完结',
  hiatus: '停更中',
};

export const comics = [
  {
    id: 1,
    slug: 'duzhe-de-yanzhong',
    title: '读者的眼中',
    author: '金秀贤',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20romance%20high%20school%20love%20story%20with%20boy%20and%20girl%20under%20cherry%20blossoms%20soft%20pastel%20colors%20clean%20simple%20background%20comic%20book%20illustration%20high%20quality%20warm%20atmosphere&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: 'serializing',
    rating: 9.6,
    views: 12850000,
    description: '某天，平凡的女高中生韩素希不小心发现了班里最受欢迎的男生朴志训的秘密——他是个重度小说迷。为了保守秘密，素希成了他的\u201C共犯\u201D，却在不知不觉中走进了他的世界。一段关于青春、秘密与初恋的浪漫故事就此展开。',
    tags: ['校园', '初恋', '甜宠', '少年'],
    chapters: 156,
    updateDate: '2026-07-07',
    featured: true,
  },
  {
    id: 2,
    slug: 'anhei-zhishen',
    title: '暗黑之神',
    author: '李恩在',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20dark%20mystery%20thriller%20detective%20in%20rainy%20Seoul%20night%20street%20moody%20atmosphere%20dramatic%20lighting%20clean%20simple%20background%20comic%20book%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: 'serializing',
    rating: 9.4,
    views: 9800000,
    description: '连环杀人案打破了首尔夜晚的宁静，刑警姜泰浩在追查真相的过程中，发现所有的线索都指向了十年前已经结案的旧案。随着调查深入，一个隐藏在黑暗中的神秘组织逐渐浮出水面。',
    tags: ['悬疑', '推理', '犯罪', '反转'],
    chapters: 98,
    updateDate: '2026-07-06',
    featured: true,
  },
  {
    id: 3,
    slug: 'mofa-shaonv-chengzhangji',
    title: '魔法少女成长记',
    author: '朴智慧',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20magical%20girl%20in%20fantasy%20academy%20holding%20magic%20wand%20colorful%20sparkles%20bright%20vibrant%20clean%20simple%20background%20comic%20book%20illustration%20whimsical&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    category: '奇幻',
    categorySlug: 'qihuan',
    status: 'completed',
    rating: 9.5,
    views: 15600000,
    description: '普通中学生尹彩琳在一次意外中获得了魔法力量，从此她的人生彻底改变。在魔法学院里，她结识了一群志同道合的朋友，一起对抗邪恶势力，保护人类世界的和平。',
    tags: ['魔法', '成长', '友情', '冒险'],
    chapters: 210,
    updateDate: '2026-05-20',
    featured: true,
  },
  {
    id: 4,
    slug: 'zongcai-de-qiyue-lianren',
    title: '总裁的契约恋人',
    author: '崔允儿',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20romance%20handsome%20CEO%20in%20suit%20with%20young%20woman%20elegant%20office%20setting%20clean%20simple%20background%20comic%20book%20illustration%20sophisticated%20atmosphere&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: 'completed',
    rating: 9.3,
    views: 21300000,
    description: '为了偿还父亲的巨额债务，设计师林小夏被迫与冷面总裁韩在宇签订了一份契约恋爱协议。本以为只是一场单纯的交易，却在朝夕相处中萌生了真实的情感。',
    tags: ['契约恋爱', '总裁', '甜宠', '逆袭'],
    chapters: 188,
    updateDate: '2026-06-15',
    featured: true,
  },
  {
    id: 5,
    slug: 'jiangshi-mori',
    title: '僵尸末日',
    author: '金东旭',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20zombie%20apocalypse%20survivors%20in%20destroyed%20city%20dark%20dramatic%20orange%20sky%20clean%20simple%20background%20comic%20book%20illustration%20intense%20atmosphere&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    category: '恐怖',
    categorySlug: 'kongbu',
    status: 'serializing',
    rating: 9.2,
    views: 11200000,
    description: '一场突如其来的病毒席卷了首尔，感染者纷纷变成了嗜血的僵尸。幸存者们被迫在末日中求生。高中生韩志浩带领着一群幸存者，踏上了寻找安全避难所的艰难旅程。',
    tags: ['僵尸', '末日', '生存', '人性'],
    chapters: 134,
    updateDate: '2026-07-07',
    featured: false,
  },
  {
    id: 6,
    slug: 'jianxi-aiti',
    title: '见习爱体',
    author: '张美兰',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20sports%20university%20athletic%20young%20man%20and%20woman%20in%20training%20wear%20sunny%20campus%20clean%20simple%20background%20comic%20book%20illustration%20fresh%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    category: '校园',
    categorySlug: 'xiaoen',
    status: 'serializing',
    rating: 9.1,
    views: 8900000,
    description: '体育大学的新生李夏天，在入学第一天就遇到了传说中的\u201C魔鬼教练\u201D——大四学长金泰亨。严苛的训练与意外的温柔交织，一段关于汗水与心动的校园故事。',
    tags: ['体育', '校园', '学长', '热血'],
    chapters: 89,
    updateDate: '2026-07-05',
    featured: false,
  },
  {
    id: 7,
    slug: 'dushi-lieren',
    title: '都市猎人',
    author: '赵成浩',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20action%20hero%20former%20special%20forces%20man%20in%20black%20coat%20Seoul%20night%20cityscape%20clean%20simple%20background%20comic%20book%20illustration%20cool%20atmosphere&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    category: '动作',
    categorySlug: 'dongzuo',
    status: 'completed',
    rating: 9.5,
    views: 18900000,
    description: '退役特种兵姜宇镇回到首尔，本想平静生活的他却意外卷入了一场涉及政商黑幕的巨大阴谋。凭借过人的身手和智慧，他化身为黑夜中的都市猎人，锄强扶弱。',
    tags: ['动作', '都市', '特种兵', '正义'],
    chapters: 245,
    updateDate: '2026-04-10',
    featured: true,
  },
  {
    id: 8,
    slug: 'gaoxiao-riji',
    title: '搞笑日记',
    author: '吴世勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20comedy%20four%20roommates%20in%20messy%20college%20dorm%20funny%20expressions%20bright%20colorful%20clean%20simple%20background%20comic%20book%20illustration%20humorous&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: 'serializing',
    rating: 9.0,
    views: 7600000,
    description: '一个社恐宅男和他的三个奇葩室友的爆笑日常。从外卖被偷到期末考试集体翻车，每一页都是笑点满满的生活段子。',
    tags: ['搞笑', '日常', '室友', '治愈'],
    chapters: 112,
    updateDate: '2026-07-06',
    featured: false,
  },
  {
    id: 9,
    slug: 'xingji-qiyuan',
    title: '星际起源',
    author: '郑宇宙',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20sci-fi%20space%20explorer%20in%20futuristic%20spacesuit%20stars%20and%20galaxy%20background%20clean%20simple%20composition%20comic%20book%20illustration%20epic%20atmosphere&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    category: '科幻',
    categorySlug: 'kehuan',
    status: 'serializing',
    rating: 9.3,
    views: 10200000,
    description: '公元2245年，人类已经建立了遍布银河系的星际文明。年轻的探险家金星辰在一次深空任务中发现了外星文明的遗迹，揭开了人类起源的惊天秘密。',
    tags: ['科幻', '星际', '探险', '外星'],
    chapters: 167,
    updateDate: '2026-07-04',
    featured: false,
  },
  {
    id: 10,
    slug: 'jianxia-fengyun',
    title: '剑侠风云',
    author: '武侠宗',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20martial%20arts%20swordsman%20in%20ancient%20Chinese%20style%20robes%20holding%20sword%20misty%20mountain%20background%20clean%20simple%20composition%20comic%20book%20illustration&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    category: '古装',
    categorySlug: 'guzhuang',
    status: 'completed',
    rating: 9.6,
    views: 17800000,
    description: '少年独孤云天生拥有绝世剑骨，却被诬陷为魔教余孽。为了洗清冤屈，他踏上了江湖之路，在血与火的历练中逐渐成长为一代剑侠。',
    tags: ['古装', '武侠', '剑客', '江湖'],
    chapters: 320,
    updateDate: '2026-03-01',
    featured: true,
  },
  {
    id: 11,
    slug: 'yiwai-de-baifu',
    title: '意外的伯父',
    author: '南宫珉',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20comedy%20countryside%20man%20and%20city%20girl%20awkward%20meeting%20bright%20warm%20colors%20clean%20simple%20background%20comic%20book%20illustration%20funny%20vibe&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    category: '搞笑',
    categorySlug: 'gaoxiao',
    status: 'serializing',
    rating: 8.9,
    views: 5400000,
    description: '高中生金多美突然多了一个从天而降的伯父，而且这位伯父还是个来自乡下的土老帽！都市少女和乡下伯父的同居生活，笑料百出。',
    tags: ['搞笑', '家庭', '日常', '温馨'],
    chapters: 67,
    updateDate: '2026-07-07',
    featured: false,
  },
  {
    id: 12,
    slug: 'xuexing-zhiye',
    title: '血腥之夜',
    author: '黑暗工作室',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20horror%20abandoned%20school%20building%20full%20moon%20night%20mysterious%20shadow%20dark%20eerie%20atmosphere%20clean%20simple%20composition%20comic%20book%20illustration%20spooky&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    category: '恐怖',
    categorySlug: 'kongbu',
    status: 'completed',
    rating: 9.4,
    views: 13500000,
    description: '一所偏僻的寄宿学校里，每到月圆之夜就会发生离奇的死亡事件。转学生金荷娜无意中发现了学校隐藏的秘密——这里曾经是日军的人体实验基地。',
    tags: ['恐怖', '校园', '惊悚', '历史'],
    chapters: 156,
    updateDate: '2026-05-30',
    featured: false,
  },
  {
    id: 13,
    slug: 'wuxian-fuchou',
    title: '无限复仇',
    author: '复仇者联盟',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20revenge%20thriller%20mysterious%20man%20in%20shadow%20with%20intense%20gaze%20dark%20urban%20alley%20moody%20lighting%20clean%20simple%20background%20comic%20book%20illustration&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    category: '悬疑',
    categorySlug: 'xuanyi',
    status: 'serializing',
    rating: 9.2,
    views: 8700000,
    description: '当所有人都以为他已经死了的时候，他带着全新的身份回来了。十年的隐忍，只为这一刻的复仇。然而在复仇的过程中，他却发现真相远比想象中更加残酷。',
    tags: ['悬疑', '复仇', '反转', '虐心'],
    chapters: 78,
    updateDate: '2026-07-06',
    featured: false,
  },
  {
    id: 14,
    slug: 'chongzu-juexing',
    title: '种族觉醒',
    author: '金贤重',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20supernatural%20awakening%20young%20man%20with%20glowing%20energy%20around%20hands%20modern%20city%20background%20clean%20simple%20composition%20comic%20book%20illustration%20powerful&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: 'serializing',
    rating: 9.5,
    views: 14500000,
    description: '普通上班族李明宇某天突然觉醒了远古种族的力量。在这个隐藏着超能力者的世界里，他不得不学会掌控自己的力量，同时面对来自各方的威胁与挑战。',
    tags: ['玄幻', '超能力', '觉醒', '战斗'],
    chapters: 201,
    updateDate: '2026-07-07',
    featured: false,
  },
  {
    id: 15,
    slug: 'lanqiu-zhiwang',
    title: '篮球之王',
    author: '运动狂',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20basketball%20player%20dunking%20on%20court%20dynamic%20action%20pose%20bright%20stadium%20lighting%20clean%20simple%20background%20comic%20book%20illustration%20energetic&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    category: '体育',
    categorySlug: 'tiyu',
    status: 'serializing',
    rating: 9.1,
    views: 6900000,
    description: '身高只有168cm的高中生朴智成，凭借着惊人的弹跳力和不懈的努力，一步步从街头篮球走向职业赛场。他的目标是——成为韩国篮球史上最伟大的球员。',
    tags: ['体育', '篮球', '热血', '梦想'],
    chapters: 145,
    updateDate: '2026-07-05',
    featured: false,
  },
  {
    id: 16,
    slug: 'dushi-mowang',
    title: '都市魔王',
    author: '幻想工坊',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20demon%20king%20in%20modern%20Seoul%20street%20confused%20expression%20comedy%20fantasy%20clean%20simple%20background%20comic%20book%20illustration%20humorous&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    category: '都市',
    categorySlug: 'dushi',
    status: 'completed',
    rating: 9.4,
    views: 16700000,
    description: '魔界最强的魔王大人因为在魔界太无聊，决定来人间体验生活。然而刚到首尔的第一天就被小混混盯上，还被高中生女主当成流浪汉捡回了家……',
    tags: ['都市', '魔王', '搞笑', '反差'],
    chapters: 178,
    updateDate: '2026-06-20',
    featured: false,
  },
  {
    id: 17,
    slug: 'milian-zhiguang',
    title: '迷练之光',
    author: '星光社',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20idol%20trainee%20girl%20in%20dance%20practice%20room%20mirror%20reflection%20soft%20lighting%20clean%20simple%20background%20comic%20book%20illustration%20dreamy&width=600&height=800&seq=comic-cover-17&orientation=portrait',
    category: '恋爱',
    categorySlug: 'lianai',
    status: 'serializing',
    rating: 9.3,
    views: 9200000,
    description: '练习生金艺琳在出道前的最后三个月，遇到了身为顶级偶像的导师车恩宇。在残酷的练习生活和朦胧的暧昧之间，她必须做出选择——是追逐梦想还是守护爱情？',
    tags: ['偶像', '练习生', '暗恋', '娱乐圈'],
    chapters: 93,
    updateDate: '2026-07-06',
    featured: false,
  },
  {
    id: 18,
    slug: 'yongsheng-zhe',
    title: '永生者',
    author: '时空旅人',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20art%20style%20immortal%20man%20through%20different%20historical%20eras%20Joseon%20dynasty%20to%20modern%20Seoul%20epic%20timeless%20feel%20clean%20simple%20background%20comic%20book%20illustration&width=600&height=800&seq=comic-cover-18&orientation=portrait',
    category: '玄幻',
    categorySlug: 'xuanhuan',
    status: 'completed',
    rating: 9.7,
    views: 23400000,
    description: '活了五百年的不死者韩在熙，见证了朝鲜王朝的兴衰、日据时期的苦难、韩战的创伤。在现代首尔，他遇到了一个与前世的挚爱长得一模一样的女孩……',
    tags: ['玄幻', '永生', '轮回', '虐恋'],
    chapters: 280,
    updateDate: '2026-02-14',
    featured: true,
  },
];

export const rankings = {
  weekly: [18, 10, 7, 3, 1, 14, 5, 2, 4, 16],
  monthly: [18, 3, 7, 10, 4, 1, 14, 5, 16, 2],
  total: [4, 18, 7, 10, 3, 16, 14, 1, 5, 2],
};

export const testimonials = [
  {
    name: '漫迷小王',
    role: '韩漫爱好者 · 3年老用户',
    content: '这是我用过最全的韩漫网站！每天上班摸鱼必备，更新速度超快，比别的地方快好几天。画质也很清晰，强烈推荐给所有喜欢韩漫的朋友！',
    avatarSeq: 'user-01',
  },
  {
    name: '樱花落',
    role: '资深读者 · 收藏2000+部',
    content: '从大学开始就在这里看韩漫了，三年多了。分类很全，找漫画特别方便。最喜欢的是可以收藏喜欢的作品，追更提醒也很及时，再也不用担心错过更新了。',
    avatarSeq: 'user-02',
  },
  {
    name: '追更达人',
    role: 'VIP用户 · 每日必逛',
    content: '韩国漫画大全真的是宝藏网站！不仅有热门的连载作品，还有很多冷门但超好看的老漫。免费阅读真的是太良心了，我已经安利给身边所有朋友了。',
    avatarSeq: 'user-03',
  },
];

export const siteInfo = {
  name: '韩国漫画大全',
  description: '韩国漫画大全网收录超万部韩漫作品，全部免费在线阅读，涵盖连载与完结经典之作，每日更新热门韩漫，适合韩漫爱好者收藏的一站式阅读平台。',
  foundedYear: 2019,
  totalComics: 12800,
  dailyVisitors: 500000,
  monthlyActive: 3800000,
  totalChapters: 2500000,
  contactEmail: 'hello@w340q.cn',
  address: '首尔特别市江南区驿三洞',
};